import { useDispatch, useSelector } from 'react-redux';
import { HubspotFormModal } from '../../common/HubspotFormModal';
import {
  selectIsEnterpriseFormOpen,
  setEnterpriseFormDialogOpen,
} from '../../redux/slicers/subscriptionSlicer';

export const EnterpriseForm = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectIsEnterpriseFormOpen);

  return (
    <HubspotFormModal
      title="Enterprise Form"
      portalId="6917454"
      formId="5100a312-2f2f-4031-a356-0c7ce8396b1e"
      open={open}
      onClose={() => dispatch(setEnterpriseFormDialogOpen(false))}
    />
  );
};
